<template>
  <div class="tables-basic">
    <b-breadcrumb>
      <b-breadcrumb-item>Sale</b-breadcrumb-item>
      <b-breadcrumb-item active>Customers</b-breadcrumb-item>
    </b-breadcrumb>
    <b-row>
      <b-col lg="12"></b-col>
      <b-col lg="12" class="text-right" style="padding:10px">
        <router-link :to="{ path: '/app/sales/customers-edit/0'}">
          <b-button pill variant="outline-primary">Add New</b-button>
        </router-link>
      </b-col>
      <b-col lg="12">
        <Widget title="<h5>Search Customers</h5>" customHeader>
          <b-form @submit="onSearchSubmit">
            <b-form-group
              id="input-group-2"
              label-for="input-2"
              description="Search patient by name , phone number, NOK name or NHIF number"
            >
              <b-form-input
                id="input-2"
                v-model="search"
                required
                placeholder="Enter search details"
                @change="onSearchChange"
                @keydown="onSearchChange"
              ></b-form-input>
            </b-form-group>
          </b-form>
        </Widget>

        <Widget title="<h5>Patients</h5>" customHeader>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Phone Number</th>
                  <th>NOK</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" v-bind:key="item.id">
                  <td>
                    <a v-bind:href="'/app/patient/' + item.id">{{ item.primaryNumber }}</a>
                  </td>
                  <td>
                    <a v-bind:href="'/app/patient/' + item.id">{{ item.fullName }}</a>
                  </td>
                  <td>{{ item.gender.name }}</td>
                  <td>{{ item.age }}</td>
                  <td>{{ item.contact.mobileNumber }}</td>
                  <td>{{ item.nok.firstName + ' ' + item.nok.lastName }}</td>
                  <td>
                    <b-badge :variant="getStatus(item.patientStatus)" pill>{{ item.patientStatus }}</b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import userApi from "@/services/userApi";
//import patientApi from "@/services/patientApi";

export default {
  name: "PatientList",
  components: { Widget },
  data() {
    return {
      search: "",
      items: []
    };
  },
  methods: {
    onSearchSubmit(evt) {
      evt.preventDefault();
      this.searchServer(this.search);
    },
    onSearchChange() {
      if (this.search.length > 4) {
        this.searchServer(this.search);
      }
    },
    searchServer(search) {
      patientApi
        .getAll(search)
        .then(response => {
          this.items = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getStatus(patientStatus) {
      if (patientStatus === "Not in hospital") {
        return "gray";
      }
      if (patientStatus === "Admitted") {
        return "warning";
      }
      if (patientStatus === "In hospital") {
        return "primary";
      }
    }
  },
  beforeCreate() {
    userApi.isLoggedIn(this.$router);
  }
};
</script>

<style src="./Style.scss" lang="scss" scoped />
